// Single source of truth for the RUNNING bundle's release. MUST be bumped in
// lockstep with /public/version.json on every release — the VersionBadge
// compares the two and hard-refreshes stale PWAs (the recurring "it didn't
// deploy" complaints were browsers pinning an old cached bundle).
export const APP_RELEASE = "v414.98";
